import { differenceInMilliseconds } from "date-fns/fp";
import { WorkingStatus } from "../redux/api-model/employees/workContract";
import { TimetrackingRequestDto } from "../redux/api-model/employees/workSchedule";

export const convertDuration = (duration?: string): string => {
  if (duration) {
    if (duration == "PT0S") return "00:00";
    const durationRegex = /PT(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/;
    const [, h, m] = duration.match(durationRegex) ?? [];

    const hours = h === undefined ? 0 : parseInt(h, 10);
    const minutes = m === undefined ? 0 : parseInt(m, 10);

    return `${addLeadingZero(hours)}:${addLeadingZero(minutes)}`;
  }
  return "";
};

export const getDurationInMin = (duration?: string): number => {
  if (duration) {
    if (duration == "PT0S") return 0;
    const durationRegex = /PT(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/;
    const [, h, m] = duration.match(durationRegex) ?? [];

    const hours = h === undefined ? 0 : parseInt(h, 10);
    const minutes = m === undefined ? 0 : parseInt(m, 10);

    return hours * 60 + minutes;
  }
  return 0;
};

export const convertDurationToHm = (duration?: string): string => {
  if (duration) {
    if (duration == "PT0S") return "0h";
    const durationRegex = /PT(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/;
    const [, h, m] = duration.match(durationRegex) ?? [];

    const hours = h === undefined ? "" : `${parseInt(h, 10)}h`;
    const minutes = m === undefined ? "" : `${parseInt(m, 10)}m`;

    return `${hours}${minutes}`;
  }
  return "0h";
};

const zeroPad = (num?: number): string => String(num).padStart(2, "0");

export const convertMinutesToHHMM = (totalMinutes: number): string => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${hours}:${zeroPad(minutes)}`;
};

// 1h20m
export const convertMinutesToHm = (totalMinutes: number): string => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const h = hours === 0 ? "" : `${hours}h`;
  const m = minutes === 0 ? "" : `${minutes}m`;

  return `${h}${m}`;
};

export function addLeadingZero(value: number | undefined = 0): string {
  return String(value).length > 1 ? String(value) : "0" + value;
}

// Transforms time string 10:00 to milliseconds
export const toMilliseconds = (time?: string): number => {
  if (!time) {
    return 0;
  }
  const [hours, minutes] = time.split(":");

  return (
    parseInt(hours, 10) * 60 * 60 * 1000 + 60 * 1000 * parseInt(minutes, 10)
  );
};

export function getTotalDuration(
  currentTime: Date,
  working?: WorkingStatus,
  workingTimetrackingRequest?: TimetrackingRequestDto
): number {
  const { breaks, startTime } =
    workingTimetrackingRequest as TimetrackingRequestDto;
  let totalDurationInMilliseconds = 0;

  if (Array.isArray(breaks) && breaks.length > 0) {
    breaks.forEach((value, index) => {
      if (index === 0) {
        totalDurationInMilliseconds += differenceInMilliseconds(
          new Date(startTime),
          new Date(value.start)
        );
      } else {
        totalDurationInMilliseconds += differenceInMilliseconds(
          new Date(breaks[index - 1].end),
          new Date(value.start)
        );
      }
    });

    if (working === WorkingStatus.WORKING) {
      totalDurationInMilliseconds += differenceInMilliseconds(
        new Date(breaks[breaks.length - 1].end),
        currentTime
      );
    }
  } else {
    totalDurationInMilliseconds = differenceInMilliseconds(
      new Date(startTime),
      currentTime
    );
  }
  return totalDurationInMilliseconds;
}

export function getLastInterval(
  currentTime: Date,
  working?: WorkingStatus,
  workingTimetrackingRequest?: TimetrackingRequestDto
): number {
  const { breaks, startTime } =
    workingTimetrackingRequest as TimetrackingRequestDto;
  let lastIntervalInMilliseconds;

  if (Array.isArray(breaks) && breaks.length > 0) {
    if (working === WorkingStatus.WORKING) {
      lastIntervalInMilliseconds = differenceInMilliseconds(
        new Date(breaks[breaks.length - 1].end),
        currentTime
      );
    } else {
      lastIntervalInMilliseconds = differenceInMilliseconds(
        new Date(breaks[breaks.length - 1].start),
        currentTime
      );
    }
  } else {
    lastIntervalInMilliseconds = differenceInMilliseconds(
      new Date(startTime),
      currentTime
    );
  }

  return lastIntervalInMilliseconds;
}
